export const constTrue = () => true

export const identity = <A>(x: A) => x
